import * as angular from 'angular';

import {
  Inject,
  Injectable,
} from 'ng-metadata/core';

@Injectable('bugsnagClient')
export class BugsnagService {
  public FS = (<any>window).FS;
  public bugsnagJs = (<any>window).bugsnag;
  public bugsnagClient;

  constructor(
    @Inject('$log') private $log: ng.ILogService,
  ) {
    if (this.bugsnagJs) {
      this.bugsnagClient = this.bugsnagJs('35bd15e8390f5652aed3a041551649a6');
    }
  }

  notify(err, opts?) {
    if (!this.bugsnagClient || process.env.MIX_ENV !== 'prod') {
      return;
    }

    const options: any = {};

    // Make sure FullStory object exists.
    if (this.FS && this.FS.getCurrentSessionURL) {
      options.beforeSend = (report) => {
        report.updateMetaData('fullstory', {
          urlAtTime: this.FS.getCurrentSessionURL(true),
        });
      };
    }

    angular.extend(options, opts);

    this.bugsnagClient.notify(err, options);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/services/bugsnag.service.ts